const TIPOS_ESTADOS_DESCARGA_DOWNLOADED = [2, 10, 18, 13, 11, 20, 7]

export {
  TIPOS_ESTADOS_DESCARGA_DOWNLOADED
}
